import { useCallback, useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import LoginUpdateNoticeService from "../services/loginUpdateNoticeService";
import LoginUpdateNoticeAnalyticsService from "../services/loginUpdateNoticeAnalyticsService";

export function useLoginUpdateNotice() {
  const [notice, setNotice] = useState(null);
  const [open, setOpen] = useState(false);
  const [interactionId, setInteractionId] = useState(null);

  // Garante que a impressão da campanha só é disparada uma única vez por
  // efetiva exibição do modal (não por fetch/retry da campanha).
  const impressionFiredForNoticeIdRef = useRef(null);

  const checkCurrentNotice = useCallback(async () => {
    try {
      const current = await LoginUpdateNoticeService.getCurrent();
      setNotice(current);
      setInteractionId(current ? uuidv4() : null);
      setOpen(Boolean(current));
    } catch {
      setNotice(null);
      setInteractionId(null);
      setOpen(false);
    }
  }, []);

  const closeNotice = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    if (!open || !notice?.id) return;
    if (impressionFiredForNoticeIdRef.current === notice.id) return;

    impressionFiredForNoticeIdRef.current = notice.id;

    const impressionEventId = uuidv4();

    LoginUpdateNoticeAnalyticsService.trackImpression(notice.id, {
      eventId: impressionEventId,
      interactionId,
    });
  }, [open, notice, interactionId]);

  return {
    notice,
    open,
    setOpen,
    checkCurrentNotice,
    closeNotice,
    interactionId,
  };
}
